import { action } from './index';

export const SET_OFFSET = 'SET_OFFSET';

export const setOffset = offset => action(SET_OFFSET, { offset });
